import React from 'react'
import {TextField, Grid} from '@mui/material'

export interface ReviewerCommentsProps {
  reviewerComments: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onBlur: () => void,
  error: boolean | undefined,
  disabled: boolean,
  dataTestId?: string
  label?: string
}

function ReviewerComments({
                            reviewerComments,
                            onChange,
                            onBlur,
                            error,
                            disabled,
                            dataTestId,
  label,
                          }: ReviewerCommentsProps) {
  return (
    <Grid item xs={12} style={{marginTop: '16px', transition: 'height 1.5s ease-in-out'}}>
      <TextField
        label={label}
        fullWidth
        multiline
        rows={4}
        value={reviewerComments}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
        data-testid={dataTestId}
      />
    </Grid>
  )
}

export default ReviewerComments